import React, { useState } from 'react';
import { Button } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { stopTimer } from 'modules/blok-test';
import { setConfirmationModal } from 'modules/global';
import { useFinishTest } from 'modules/mavzuli-test';

import { Modal, WarningModal } from 'components';

import ResultsModal from './results-modal';

interface IProps {
  ticketId?: number;
  testType: string;
  isExam?: boolean;
  onConfirm?: () => void;
  onAfterClose?: () => void;
}

const ConfirmationModal: React.FC<IProps> = ({ onAfterClose, ticketId, onConfirm, testType, isExam = false }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const [id, setId] = useState<number>();
  const isUserRegistered = useAppSelector(state => state.user.phone);
  const [openResults, setOpenResults] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const open = useAppSelector(({ confirmationModal }) => confirmationModal.open);
  const { finishTest } = useFinishTest({ ticketId: id, onClose: onAfterClose, setOpenResults });

  const onOk = () => {
    setId(ticketId);

    dispatch(stopTimer());
    dispatch(setConfirmationModal(false));

    if (onConfirm) {
      onConfirm();
    }
    setOpenWarning(true);
  };

  const onClose = () => {
    dispatch(setConfirmationModal(false));

    if (onAfterClose) onAfterClose();
  };

  return (
    <>
      <Modal
        footer={false}
        open={open}
        centered
        onClose={onClose}
        width="380px"
        closeIcon={false}
        styles={{
          content: { padding: '8px 10px 3px 10px', borderRadius: '12px' }
        }}
      >
        <div className="mb-5 flex flex-col items-center justify-center">
          <div className="relative size-15">
            <Image src="/images/confirmation.webp" fill alt="Confirmation" title="Confirmation" />
          </div>
          <p className="mt-3 text-lg font-semibold">{t('testni_yakunlashni_xohlaysizmi')}</p>
          <p className="mt-2 px-5 text-center text-gray-400">{t('testni_yakunlashni_xohlaysizmi_decs')}</p>
        </div>
        <div className="mt-10 flex items-center gap-2">
          <Button
            onClick={onClose}
            className="!py-4.5 !w-full !rounded-md !border-transparent !bg-gray-100 !text-black hover:!bg-gray-200"
          >
            {t('bekor_qilish')}
          </Button>
          <Button
            onClick={onOk}
            className="!py-4.5 !w-full !rounded-md !border-transparent !bg-red-500 !text-white hover:!bg-red-600"
          >
            {t('yakunlash')}
          </Button>
        </div>
      </Modal>

      {finishTest &&
        (isExam || !isUserRegistered ? (
          <WarningModal
            testType={testType}
            isExam={isExam}
            ticketId={ticketId}
            onClose={() => setOpenWarning(false)}
            open={openWarning}
          />
        ) : (
          <ResultsModal ticketId={ticketId} onClose={() => setOpenResults(false)} open={openResults} />
        ))}
    </>
  );
};

export default ConfirmationModal;
